<script>
    export var mod_index, updateCallback, values;
    import Chart from 'chart.js/auto';
    import { onMount } from 'svelte';

    //https://stackoverflow.com/questions/43757979/chart-js-drag-points-on-linear-chart/48062137#48062137
    //https://github.com/chrispahm/chartjs-plugin-dragData
    //https://www.chartjs.org/docs/latest/
    
    Chart.defaults.plugins.legend = {
            enabled: false,
            display: false
        };

    //const labels = Utils.months({count: 7});
    const data = {
        labels: [0, 1, 2,3,4,5,6],
        datasets: [{
            label: 'Tension',
            data: [0, 10, 5, 25, 20, 40, 0],
            fill: false,
            borderColor: '#6E32CF',
            borderWidth: 5,
            tension: 0.35
        }]
    }

    const config = {
        type: 'line',
        data: data,
        options: {
            title:{
                display: false
            },
            legend:{
                display: false
            },
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        }
    };
    

    onMount(async () => {
		const ctx = document.getElementById('Tchart').getContext('2d');
        var Tchart = new Chart(ctx, config)
	});

</script>

<div class="module">
    <canvas class="Tchart" id="Tchart"></canvas>
</div>

<style lang="scss">
    @use "styles/global.scss";

    .module{
        @include module;

        width: 1022px;
        height: 576px;

        .Tchart{
            width: 100%;
            height: 100%;
        }
    }
</style>



